<script lang="ts">
	import { createEventDispatcher } from "svelte";

	import type { Recipe } from "./recipe.types";

	export let recipe: Recipe;
	export let simple: boolean = false;
	let hovered: boolean = false;
	const dispatch = createEventDispatcher();
</script>

<div
	class="recipe-holder"
	class:simple
	class:hovered
	on:mouseenter={() => (hovered = true)}
	on:mouseleave={() => (hovered = false)}
	on:click={() => dispatch("clicked", { recipe: recipe })}
>
	{#if simple}
		<img class="simple grid-full" alt="recipe pic" src={recipe.image} />
		<p class="simple grid-full">{recipe.title.slice(0, 12)}...</p>
	{:else}
		<p class="grid-full">{recipe.title.slice(0, 20)}</p>
		<img
			class:simple
			class="grid-full"
			alt="recipe pic"
			src={recipe.image}
		/>
	{/if}
	<slot />
</div>

<style>
	img {
		display: inline;
		width: 50px;
		height: 50px;
	}
	p {
		display: block;
	}
	.recipe-holder {
		background: var(--background-2);
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-gap: 1em;
		justify-items: center;
		outline: 2px solid var(--background-4);
		margin: 15px;
		padding: 10px;
		cursor: pointer;
	}
	.recipe-holder.simple {
		margin: 8px;
	}
	.hovered {
		outline: 2px solid var(--button-secondary);
	}
	img.simple {
		width: 40px;
		height: 40px;
		display: inline;
	}
	p.simple {
		display: inline;
	}
	@media (min-width: 640px) and (min-height: 500px) {
		img {
			width: 100px;
			height: 100px;
		}
	}
</style>
